// src/Components/ControlRoom/MapComponent.js
import React, { useEffect, useState } from 'react';
import {
    AdvancedMarker,
    APIProvider,
    Map,
    Marker,
    useMap,
    useMapsLibrary
} from '@vis.gl/react-google-maps';
import WhereSystem from '../../WhereSystem';
import WhereEventNames from '../../EventSystem/WhereEventNames';
import GMapUtils from '../../Utills/GMapUtils';

// TODO: Move API key to environment variable for security
const API_KEY = 'AIzaSyDlCn3SWN5zBAc6Cr2ouDZ0NymPy1yuWJw';
const globalMapLibrary = {map:null};



const Directions = ({ origin, destination,afterResp }) => {
  const map = useMap();
  const routesLibrary = useMapsLibrary('routes');
  const [directionsService, setDirectionsService] = useState();
  const [directionsRenderer, setDirectionsRenderer] = useState();
  const [routes,setRoutes] = useState([])

  // Initialize the services
  useEffect(() => {
    if (!routesLibrary || !map) return;
    WhereSystem.Map = map;
    setDirectionsService(new routesLibrary.DirectionsService());
    setDirectionsRenderer(new routesLibrary.DirectionsRenderer({ map }));
  
  }, [routesLibrary, map]);

  // Calculate directions
  useEffect(() => {
    if (!directionsService || !directionsRenderer || !origin || !destination) return;

    directionsService
      .route({
        origin,
        destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
        provideRouteAlternatives: false
      })
      .then((response) => {
        directionsRenderer.setDirections(response);
        afterResp(response);
      });

    return () => directionsRenderer.setMap(null);
  }, [directionsService, directionsRenderer, origin, destination]);



    return null;
};

const MapObject = ()=>{
    globalMapLibrary.map = useMap();
    return (null)
}

// Reusable map component that can be embedded in different layouts
 function MapComponent(props) {
    const [showDirection, setShowDirection] = useState(false);
    const [routeData,setRouteData] = useState(null);
    const [routes, setRoutes] = useState([]);
    const [mapMarkers, setMapMarkers] = useState([])
    //const [markers, setMarkers] = useState([{position:{lng:46.710594, lat:24.782244}, title:"Riyad Center"}])
    const [mapCenter,setMapCenter] = useState({ lat: 24.782244, lng: 46.710594 });
  
    
    useEffect((e) => {
        WhereSystem.EventSystem.registerForEventWithTag(WhereEventNames.ADD_MARKERS, (markerParams) => {
            const markers = markerParams.markers;
            markers.forEach(marker => {
                marker.position.lat = parseFloat(marker.position.lat);
                marker.position.lng = parseFloat(marker.position.lng);
            });
            let newArr = [];
            if(markerParams.clearOld)
            {
                newArr = [...markers];
            }
            else
            {
                newArr = [...mapMarkers,...markers];
                
            }

            setMapMarkers(newArr);
            if(newArr.length == 1)
            {
                globalMapLibrary.map.setCenter(markers[0].position);
            }
            else
            {
                GMapUtils.fitMarkersInMapBounds(globalMapLibrary.map,newArr)
            }
            
            //globalMapLibrary.map.setCenter(markers[0].position);
        },"mapLoadEvent")
        
    },[mapMarkers])
    
    useEffect (() =>{
         WhereSystem.EventSystem.registerForEvent(WhereEventNames.DO_ROUTING, (routeData) => {
            const newRoutes = [...routeData];
            setRoutes(newRoutes);
            setShowDirection(true);
        })
    },{showDirection,routes})
    return (
        <>
           
            <APIProvider apiKey={API_KEY}>
                <Map
                    mapId={'bf51a910020fa25a'} // A mapId is recommended
                    defaultZoom={15}
                    defaultCenter={mapCenter}
                    gestureHandling={'greedy'}
                    style={props.style}
                    
                >
                    <MapObject />
                    {showDirection &&
                    
                        routes.map((route) =>{
                            <Directions origin={route.routingPoints.origin.join(",")} destination={routeData.routingPoints.destination.join(",")} afterResp={routeData.afterResp}/>
                        })
                    
                    
                    }
                    {
                        mapMarkers.map((marker, index) => {
                            return <Marker key={index} position={marker.position} title={marker.title} icon={marker.icon}/>
                        })
                    }

                 
                </Map>
            </APIProvider>
        </>
    );
};

export default MapComponent;
